import { Dispatcher } from 'flux';

const dispatch = new Dispatcher();
export default dispatch;
